import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/Header.css";
import "./styles/Signup.css";
import "./styles/Homepage.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
